import { hasIn } from "lodash";
import { isBrowser } from "~/utilities/helpers";

// When in sub navigation dropdown on mobile menu and tabbing through items,
// Tabbing should rotate through current sub nav
// CW-1242
export const navigateMenuWithKeyboard = ({
    keyboardEvent,
    mobileMenuIsOpen,
    finalLinkMobileRef,
    mobileNavExitRef,
    mobileNavRef,
}) => {
    const focusedElement = document.activeElement;

    if (
        mobileMenuIsOpen &&
        finalLinkMobileRef.current &&
        mobileNavExitRef.current
    ) {
        if (!keyboardEvent.shiftKey) {
            if (
                focusedElement === finalLinkMobileRef.current.firstElementChild
            ) {
                keyboardEvent.preventDefault();
                mobileNavRef.current.focus();
            }
        } else if (focusedElement === mobileNavExitRef.current) {
            keyboardEvent.preventDefault();
            finalLinkMobileRef.current.firstElementChild.focus();
        }
    }
};

// When sub nav is opened, focus its first element
// When sub nav is closed, focus its button that controls its menu
// CW-1243
export const adjustNavMenuFocus = ({
    menuOpened,
    mobileMenuIsOpen,
    openedSubnavs,
    mobileNavToggleRef,
    mainNavRef,
    mobileNavRef,
}) => {
    const tertiaryOpen = openedSubnavs.tertiary;

    if (!(menuOpened || mobileMenuIsOpen)) {
        if (mobileNavToggleRef.current) {
            mobileNavToggleRef.current.focus();
        }
        if (mainNavRef.current) {
            const parentLinkTarget =
                document.activeElement.getAttribute("data-parent");
            const parentElement = document.querySelector(
                `[data-label="${parentLinkTarget}-Top"]`,
            );
            if (hasIn(parentElement, ["firstElementChild"])) {
                parentElement.focus();
            }
        }
    } else if (
        menuOpened &&
        !mobileMenuIsOpen &&
        !tertiaryOpen &&
        mainNavRef.current
    ) {
        const parentLinkTarget =
            document.activeElement.getAttribute("data-parent");

        if (parentLinkTarget) {
            const parentElement = document.querySelector(
                `[data-label="${parentLinkTarget}"]`,
            );

            if (parentElement) {
                parentElement.focus();
            }
        }
    } else if (!menuOpened && mobileMenuIsOpen && mobileNavRef.current) {
        if (document.activeElement.tagName === "BODY") {
            mobileNavRef.current.focus();
        }
    } else {
        document.body.focus();
    }
};

// Do not allow user to tab off of mobile navigation
// CW-1242
export const navigateMobileMenuWithKeyboard = (
    keyboardEvent,
    mobileSubNavRef,
) => {
    if (keyboardEvent.key === "Tab") {
        if (!keyboardEvent.shiftKey) {
            if (
                keyboardEvent.currentTarget !==
                mobileSubNavRef.current.firstElementChild.firstElementChild
            ) {
                keyboardEvent.preventDefault();
            }
        } else if (
            keyboardEvent.currentTarget ===
            mobileSubNavRef.current.firstElementChild.firstElementChild
        ) {
            keyboardEvent.preventDefault();
        }
    }
};

export const setTertiaryNavPosition = (secondarySubRef, tertiarySubRef) => {
    if (isBrowser && secondarySubRef.current && tertiarySubRef.current) {
        const windowSize = window.innerWidth;
        const secondaryRight =
            secondarySubRef.current.getBoundingClientRect().right;
        const tertiaryWidth = tertiarySubRef.current.offsetWidth;

        if (secondaryRight + tertiaryWidth < windowSize) {
            tertiarySubRef.current.style.left = "100%";
            tertiarySubRef.current.style.top = 0;
        } else {
            tertiarySubRef.current.style.left = 0;
            tertiarySubRef.current.style.top = "100%";
        }
    }
};

export const setMatchSubNavHeight = (secondarySubRef, tertiarySubRef) => {
    if (isBrowser && secondarySubRef.current) {
        if (!tertiarySubRef.current) {
            secondarySubRef.current.style.height = "auto";
        } else {
            const secondaryHeight =
                secondarySubRef.current.firstElementChild.offsetHeight;
            const tertiaryHeight =
                tertiarySubRef.current.firstElementChild.offsetHeight;
            const maxHeight = Math.max(secondaryHeight, tertiaryHeight);

            secondarySubRef.current.style.height = `${maxHeight}px`;
            tertiarySubRef.current.style.height = `${maxHeight}px`;
        }
    }
};
